import React from 'react'
import styled from 'styled-components'

const SignInPageComponent = styled.div`
  &.sign-up-screens.horos-cloud {
    form {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border: 1px solid rgba(0,0,0,0.1);
      box-shadow: none;
    }
    .footer {
      margin: 0 auto;
      max-width: 400px;
      padding: 1rem;
      border: 1px solid rgba(0,0,0,0.1);
      border-top: 0;
      background: rgba(0,0,0,0.025);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      margin-bottom: 2rem;
    }
  }
`

const WistiaWrapper = styled.div`
  display: inline-block;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

const IeWarning = styled.div`
  max-width: 400px;
  padding: 1rem 1.5rem;
  background: rgba(0,0,0,0.5);
  color: white;
  margin: 0 auto;
  border-radius: 4px;
  a {
    color: white;
    font-weight: 600;
  }
  @-moz-document url-prefix() {
    display: none;
  }
  @media screen and (-webkit-min-device-pixel-ratio:0) {
    display: none;
  }
  @media (max-device-width: 600px) {
    display: none;
  }
  @supports (-ms-ime-align:auto) {
    display: none;
  }
`

export const SignInLayout = ({Content,Footer,contentProps}) => (
    <SignInPageComponent className="sign-up-screens horos-cloud">
        <div className="content">
            <img className="horos-logo" src="/public/favicon.png" alt="" />
            <Content {...contentProps}/>
            <div className="footer">
                <Footer/>
            </div>
            <WistiaWrapper>
              <span className="wistia_embed wistia_async_oa5uzcuxxp popover=true popoverContent=link">
                <a className="link" href="#">Learn more about Horos Cloud</a>
              </span>
            </WistiaWrapper>
        </div>
        <IeWarning>
          <div>
            Internet Explorer isn't supported by Horos Cloud. Use <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>, <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> or <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a> for a better experience.
          </div>
        </IeWarning>
    </SignInPageComponent>
);



// WEBPACK FOOTER //
// ./src/javascripts/signin/SignInLayout.jsx